import { forwardRef, Ref, type SVGProps } from 'react';

const SvgPlastic = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <g fill="#033532">
      <path d="M19.118 16.913v2.806l-3.72-2.166-3.662 2.166-3.476-1.83-2.99 1.83-2.866-1.526L1 18.68v-2.745l1.464-.55 2.746 1.527 2.988-1.526 3.6 1.526 3.722-1.526z" />
      <path d="M19.118 12.794V15.6l-3.72-2.166-3.662 2.166-3.476-1.83-2.99 1.83-2.866-1.526L1 14.562v-2.747l1.464-.547 2.746 1.525 2.988-1.525 3.6 1.525 3.722-1.525z" />
      <path d="m16.986 2.138-.59 1.236 1.044 5.38-.804 1.682-1.116-.474-3.722 1.526-3.6-1.526-1.96 1.002L9.18 4.906l5.432-2.31.62-1.296z" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgPlastic);
export default ForwardRef;
